import { withRouter, useParams } from "react-router-dom";
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Grid,
  Typography,
  LinearProgress,
  Link,
  Breadcrumbs,
  Box,
  Avatar
} from '@mui/material';

import { FiLayers } from 'react-icons/fi';

import Products from "../../components/Products";
import { useSelector, useDispatch } from 'react-redux';
import Actions from "../../constants/Actions";
import Slide from '@material-ui/core/Slide';
import useResponsive from '../../utils/useResponsive';

// actions
import listaFiltrarPorLinha from '../../actions/produtos/lista-filtrar-por-linha'
import listaProdutosPorLinha from "../../actions/produtos/lista-produtos-por-linha";
import listaAtributosPorLinha from "../../actions/produtos/lista-atributos-por-linha"

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const ITEM_HEIGHT = 68;
const ITEM_PADDING_TOP = 8;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function LinhaPage() {

  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const loading = useSelector(state => state.loading);
  const [value, setValue] = React.useState(0);

  const [grupoInput, setGrupoInput] = useState([]);
  const [grupo, setGrupo] = useState([]);

  const [grade, setGrade] = useState([]);
  const [gradeInput, setGradeInput] = useState([]);

  const [griffe, setGriffe] = useState([]);
  const [griffeInput, setGriffeInput] = useState([]);

  const [filial, setFilial] = useState([]);

  const [subgrupo, setSubgrupo] = useState([]);
  const [subgrupoInput, setSubgrupoInput] = useState([]);

  const [categoria, setCategoria] = useState([]);
  const [categoriaInput, setCategoriaInput] = useState([]);

  const [slidePreco, setSlidePreco] = useState([0, 2000]);
  const [inputValue, setInputValue] = React.useState('');

  const [grupos, setGrupos] = useState([]);
  const [subgrupos, setSubgrupos] = useState([]);
  const [griffes, setGriffes] = useState([]);

  const [pathOld, setPathOld] = useState("");

  //params
  const { linha } = useParams();

  const handleFiltrarProdutos = () => {
    dispatch({ type: Actions.LOADING, loading: true })
    listaFiltrarPorLinha({ grupo, subgrupo, grade, filial, griffe, linha: linha, preco: slidePreco }).then(res => {
      dispatch({ type: Actions.SET_TODOS_PRODUTOS, products: res.data.produtos });
      setOpen(false);
      dispatch({ type: Actions.LOADING, loading: false })
    }).catch(err => console.log(err));
  };

  const handleBuscarAtributosPorLinha = atributo => {
    listaAtributosPorLinha({ atributo: atributo, linha: linha, }).then(res => {
      if (atributo === 'grupo_produto') {
        setGrupos(res.data.atributos);
      } else if (atributo === 'subgrupo_produto') {
        setSubgrupos(res.data.atributos);
      } else if (atributo === 'griffe') {
        setGriffes(res.data.atributos);
      }
    }).catch(err => console.log(err));
  };

  useEffect(() => {
    if (pathOld !== linha) {
      setSubgrupo([]);
      setSubgrupoInput([]);
      setGriffe([]);
      setGriffeInput([]);
      setGrupo([]);
      setGrupoInput([]);
    }
  }, [linha]);

  useEffect(() => {
    dispatch({ type: Actions.LOADING, loading: true })
    listaProdutosPorLinha({ linha: linha }).then(res => {
      if (res.data.produtos.length > 0) {
        dispatch({ type: Actions.SET_TODOS_PRODUTOS, products: res.data.produtos });
        dispatch({ type: Actions.LOADING, loading: false })
      }
      dispatch({ type: Actions.LOADING, loading: false })
    }).catch(err => console.log(err));
  }, []);

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {loading === true ? (
        <LinearProgress sx={{ '& .MuiLinearProgress-bar': { bgcolor: '#1a1a2e' } }} />
      ) : (
        <>
          {/* Header */}
          <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5', maxWidth: '98%', mx: 'auto' }}>
            <Box sx={{ py: 2.5, px: { xs: 2, md: 3 } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
                  <FiLayers size={18} />
                </Avatar>
                <Typography variant="h5" sx={{ fontWeight: 700, textTransform: 'capitalize' }}>
                  {linha}
                </Typography>
              </Box>
              <Breadcrumbs separator=">" aria-label="breadcrumb" sx={{ ml: 6.5 }}>
                <Link color="inherit" href="/" underline="hover" sx={{ fontSize: '0.875rem' }}>
                  Pagina Inicial
                </Link>
                <Typography sx={{ fontSize: '0.875rem', color: '#1a1a2e', fontWeight: 600 }}>
                  {linha}
                </Typography>
              </Breadcrumbs>
            </Box>
          </Box>

          {/* Content */}
          <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
            <Products style={{ marginTop: 20 }} />
          </Box>
        </>
      )}
    </Box>
  )
}
export default withRouter(LinhaPage)
